export default {
  saved: "Daten wurden erfolgreich gespeichert",
  updated: "Daten wurden erfolgreich aktualisiert",
  deleted: "Daten wurden erfolgreich gelöscht",
  sent: "Anfrage wurde erfolgreich gesendet",
  error: "Systemfehler - Bitte wenden Sie sich an den Administrator",
  assets: {
    createdToastMessage: "Asset wurde erstellt",
    updatedToastMessage: "Asset wurde aktualisiert",
    deletedToastMessage: "Asset wurde gelöscht",
    tagsUpdatedToastMessage: "Asset-Tags wurden aktualisiert",
    types: {
      createdToastMessage: "Asset-Typ wurde erstellt",
      updatedToastMessage: "Asset-Typ wurde aktualisiert",
      deletedToastMessage: "Asset-Typ wurde gelöscht",
      models: {
        createdToastMessage: "Asset-Modell wurde erstellt",
        updatedToastMessage: "Asset-Modell wurde aktualisiert",
        deletedToastMessage: "Asset-Modell wurde gelöscht",
      },
    },
    attributeSets: {
      createdToastMessage: "Attributsatz wurde erstellt",
      updatedToastMessage: "Attributsatz wurde aktualisiert",
      deletedToastMessage: "Attributsatz wurde gelöscht",
      attributes: {
        createdToastMessage: "Asset-Attribut wurde erstellt",
        updatedToastMessage: "Asset-Attribut wurde aktualisiert",
        deletedToastMessage: "Asset-Attribut wurde gelöscht",
      },
    },
  },
  devices: {
    createdToastMessage: "Gerät wurde erstellt",
    activatedToastMessage: "Gerät Aktivierungstoken wurde eingereicht",
    updatedToastMessage: "Gerät wurde aktualisiert",
    deletedToastMessage: "Gerät wurde gelöscht",
    tagsUpdatedToastMessage: "Gerätetags wurden aktualisiert",
    deploymentGroups: {
      createdToastMessage: "Deployment-Gruppe wurde erstellt",
      updatedToastMessage: "Deployment-Gruppe wurde aktualisiert",
      deletedToastMessage: "Deployment-Gruppe wurde gelöscht",
      addOrRemoveDevices: { devicesUpdatedToastMessage: "Die Geräte der Deployment-Gruppe wurden aktualisiert" },
      iotApps: {
        appAddedToastMessage: "App wurde zur Deployment-Gruppe hinzugefügt",
        appRemovedToastMessage: "App wurde aus der Deployment-Gruppe entfernt",
        appVersionUpdatedToastMessage: "App-Version der Deployment-Gruppe wurde aktualisiert",
      },
      admins: {
        coAdminAddedToastMessage: "Co-admin wurde hinzugefügt",
        coAdminRemovedToastMessage: "Co-admin wurde entfernt",
        coAdminTransferredToastMessage: "Deployment-Gruppe Rechte wurden übertragen",
      },
    },
    sharedDeviceModels: {
      deviceModelSharedToastMessage: "Gerätemodell erfolgreich geteilt",
    },
  },
  apps: {
    descriptionUpdatedToastMessage: "App-Beschreibung wurde aktualisiert",
    sharedGloballyToastMessage: "App wurde für alle Mandanten freigegeben",
    sharedGloballyErrorToastMessage: "App konnte nicht freigegeben werden. Bitte versuchen Sie es erneut.",
    ratingUpdatedToastMessage: "App-Bewertung wurde aktualisiert",
    softwareToReview: {
      appsPendingReview: {
        appReviewSubmittedToastMessage: "App-Bewertung wurde eingereicht",
      },
    },
  },
  userManagement: {
    roleCreatedToastMessage: "Rolle wurde erstellt",
    userRolesUpdatedToastMessage: "Benutzerrollen wurden aktualisiert",
  },
};
